import { render, staticRenderFns } from "./ServiceArea.vue?vue&type=template&id=0b0509d7&scoped=true&"
import script from "./ServiceArea.vue?vue&type=script&lang=js&"
export * from "./ServiceArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0509d7",
  null
  
)

export default component.exports